import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import Header from './components/common/BlogHeader';
import Footer from './components/common/Footer';
import Wrapper from './components/common/Wrapper';
import store from './redux';
import './styles/common/reset.css';
import './styles/common/layout.scss';
import './styles/blog/common.scss';

const Router = BrowserRouter;

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <Route path='/'>
          <Wrapper bgColor="#cfdbe6" dotColor="#c0cbd8">
            <div className="gl-content"></div>
          </Wrapper>
        </Route>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('gl')
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <Route path='/'>
          <Header/>
        </Route>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('header')
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <Route path='/'>
          <Footer/>
        </Route>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('footer')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
